import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

import {
    useOrders, saveToken
  } from "../../context/orders/OrdersState";

import popupStyles from "../../css/custom-popup.module.css"
import { Checkbox } from "@progress/kendo-react-inputs";

const PaymentMessage = (status) => {
  const [ordersState, ordersDispatch] = useOrders();
  const [saveCredit, setSaveCredit] = useState(false);
  
  const {
    credit_process, tokens
  } = ordersState;

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();
  let orderId = query.get('order_id');
  let PelecardStatusCode = query.get('PelecardStatusCode') || status.status;
  let NewToken = query.get('Token');

  console.log(query);
  console.log(PelecardStatusCode + "!!!!!!!!!!!!!!");
  console.log(status.status);

  const [errorCodes, setErrorCodes] = useState({
    '000': 'עסקה תקינה',
    '001': 'כרטיס חסום',
    '002': 'כרטיס גנוב',
    '003': 'התקשר לחברת האשראי.',
    '004': 'סירוב.',
    '005': 'מזויף החרם כרטיס.',
    '006': 'ת.ז. או CVV שגויים',
    '007': 'קוד אישור אינו חוקי- נא לפנות למנהל המערכת.',
    '008': 'תקלה בבניית מפתח גישה לקובץ חסומים.',
    '009': 'תקלת תקשורת, יש לנסות שוב או לפנות למנהל המערכת ולמסור את קוד התשובה',
    '014': 'כרטיס לא נתמך',
    '015': 'אין התאמה בין המספר שהוקלד לפס המגנטי',
    '033': 'כרטיס לא תקין',
    '034': 'כרטיס לא רשאי לבצע במסוף זה או אין אישור לעסקה כזאת.',
    '036': 'כרטיס פג תוקף.',
    '039': 'ספרת ביקורת לא תקינה',
    '133': 'כרטיס לא תקף על פי רשימת כרטיסים תקפים של ישראכרט.',
    '506': `כרטיס לא קיים`
  });

  const handleIframeFinished = async (e) => { 
    console.log(tokens);
    console.log(NewToken);
    console.log("iframe finished!!");

    if (NewToken) {
      const token_exists = tokens.some(item => item.token === NewToken.slice(-4));

      if (!token_exists) {
        if (PelecardStatusCode === '000' && NewToken) {
          await saveToken(ordersDispatch, orderId, NewToken);
        } 
      } else {
        console.log("not saving");
      }
    }

    window.parent.postMessage({ paymentStatus: (PelecardStatusCode !== '000') ? 'fail' : 'success' }, '*');

  }

  useEffect(() => {
      if (orderId) {
        let timer = '';
        
        try {
          window.parent.postMessage({ paymentStatus: 'finished' }, '*');
          
          /*if (!credit_error) {
            timer = setTimeout(() => {
              window.parent.postMessage({ paymentStatus: 'success' }, '*');
            }, 4000);
          }*/
         
          console.log("credit_process " + credit_process);
        
          if (timer) {
            return () => clearTimeout(timer);
          }
        } catch (error) {
          console.error('Error payment and submit', error);
          if (timer) {
            return () => clearTimeout(timer);
          }
        }
      }
  }, [orderId]);

 
  return ( 
      <>
      <style>
          {`
              html, body {
                  
                  height: 100%; /* Full height */
                  margin: 0; /* Remove default margins */
                  display: flex; /* Use flexbox */
                  justify-content: center; /* Center horizontally */
                  align-items: center; /* Center vertically */
                  text-align: center; /* Center text */
              }
          `}
            </style>
      <div class="payment_thanks">
        {PelecardStatusCode !== '000' ?
        <>
          התקבלה שגיאה מחברת האשראי
          <br/>
          {errorCodes[PelecardStatusCode] ?? PelecardStatusCode}
        </> : 
          <>פרטי האשראי התקבלו בהצלחה
          {NewToken &&
            <div className="save_credit">    
              <Checkbox 
                id="saveCard" 
                checked={saveCredit} 
                onChange={(e) => setSaveCredit(e.value)} 
                label="שמור את הכרטיס שלי לשימוש עתידי"
              />
              <span>
                אנחנו לא באמת שומרים את פרטי כרטיס האשראי שלך,  
                אלא **אסימון (Token) מאובטח**,  
                שמאפשר לך לשלם בקלות ללא צורך בהזנת הפרטים מחדש.
              </span>
            </div>
          }
          </>
        }
      </div>
      <button
        className="submit btn payment_thanks_btn"
        onClick={handleIframeFinished}
      >
        אישור
      </button>

      </>
  );
};

export default PaymentMessage;